import HTTP from '../HTTP';

export default {
    getCompositions(companyId = null) {
        if (companyId) {
            return HTTP.get('/compositions', {
                params: {
                    company_id: companyId
                }
            });
        }
        return HTTP.get('/compositions');
    },
    getComposition(compositionId) {
        return HTTP.get(`/compositions/${compositionId}`);
    },
    createComposition(data) {
        return HTTP.post('/compositions', data);
    },
    editComposition(id, data) {
        return HTTP.put(`/compositions/${id}`, data);
    },
    removeComposition(compositionId) {
        return HTTP.delete(`/compositions/${compositionId}`);
    },
    getCompositionByNameAndCompanyId(data) {
        return HTTP.post('/compositions/get-composition-by-name-and-companyId', data);
    },
    getCompositionByType(data) {
        return HTTP.post('/compositions/get-composition-by-type', data);
    },
};